import { render, staticRenderFns } from "./NotInWx.vue?vue&type=template&id=77c4e5da&"
import script from "./NotInWx.vue?vue&type=script&lang=js&"
export * from "./NotInWx.vue?vue&type=script&lang=js&"
import style0 from "./NotInWx.vue?vue&type=style&index=0&id=77c4e5da&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c4e5da')) {
      api.createRecord('77c4e5da', component.options)
    } else {
      api.reload('77c4e5da', component.options)
    }
    module.hot.accept("./NotInWx.vue?vue&type=template&id=77c4e5da&", function () {
      api.rerender('77c4e5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/NotInWx.vue"
export default component.exports